import { ApiCatch } from "@/utils/decorators";
import { RatingSaveDTO } from "~/rating.type";
import { Api } from "../api.service";

export class RatingService {
  @ApiCatch
  static async saveRating(req: RatingSaveDTO) {
    const response = await Api.post("/rating", req);
    return response.data;
  }
}
